import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from "@angular/core";
import { DashboardStateService } from "@app/services/dashboard-state.service";
import { RejectedMachine } from "@app/models/dashboard.models";
import { staggerSlideIn } from "@app/animations/stagger-entrance.animation";

const DISPLAY_LIMIT = 6;

@Component({
  selector: "app-rejected-machines",
  templateUrl: "./rejected-machines.component.html",
  styleUrl: "./rejected-machines.component.scss",
  animations: [staggerSlideIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RejectedMachinesComponent {
  private readonly stateService = inject(DashboardStateService);

  readonly machines = computed<RejectedMachine[]>(
    () =>
      this.stateService.lastData()?.rejectedMachines?.slice(0, DISPLAY_LIMIT) ??
      [],
  );

  readonly animationTrigger = computed(() => this.machines());

  getPassedRate(machine: RejectedMachine): number {
    return 100 - machine.rejectionRate;
  }
}
